import axios from 'axios';
import config from 'config';
import { createApi } from 'utils/api';

const networkV1Api = axios.create({
  baseURL: config.prodDataV1ApiBaseUrl,
  params: {
    apikey: config.apiKey,
  },
});

const createProdDataV1Api = createApi(networkV1Api);
export const getProdDataV1Data = createProdDataV1Api('get');
export const patchProdDataV1Data = createProdDataV1Api('patch');
export const postProdDataV1Data = createProdDataV1Api('post');
export const putProdDataV1Data = createProdDataV1Api('put');